import { useMemo } from 'react';
import { DocumentAPI } from 'src/shared/services/api/documentAPI';
import { useQuery } from '@tanstack/react-query';

type UseDocumentStatsBatchArgs = {
  documentIds: number[];
  rangeDays: number;
  enabled?: boolean;
};

export const useDocumentStatsBatch = ({
  documentIds,
  rangeDays,
  enabled = true,
}: UseDocumentStatsBatchArgs) => {
  const idsKey = useMemo(
    () =>
      documentIds
        .slice()
        .sort((a, b) => a - b)
        .join(','),
    [documentIds],
  );

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['docStatsBatch', idsKey, rangeDays],
    queryFn: async () => {
      const documentApi = new DocumentAPI();
      return documentApi.GetStatsBatchV2(documentIds, rangeDays);
    },
    enabled: enabled && documentIds.length > 0,
  });

  const statsById = useMemo(() => {
    const next: Record<number, { all: number; unique: number }> = {};
    data?.forEach((item) => {
      next[item.id] = {
        all: item.allDownloads ?? 0,
        unique: item.uniqueDownloads ?? 0,
      };
    });
    return next;
  }, [data]);

  return { statsById, loading: isLoading, refetch };
};
